import React from 'react';

import { Text } from '@betterment/samba-react';
import { Box, Tooltip } from '@betterment/style-closet-react';

const AccountTypes: React.FC<React.PropsWithChildren<{ accountTypes: string }>> = ({ accountTypes }) => {
  if (accountTypes.split(',').length >= 3) {
    return (
      <td>
        <Tooltip label={accountTypes}>
          <Box borderBottom="1px dotted" borderColor="bmtGrey40">
            <Text css={{ fontWeight: 'normal' }}>Multiple Accounts</Text>
          </Box>
        </Tooltip>
      </td>
    );
  }
  return <td>{accountTypes}</td>;
};

export default AccountTypes;
